module.exports = __webpack_public_path__ + "img/caozuoshouce.b2e62d36.png";